import React from 'react';
import './PlanBadge.css';

/**
 * PlanBadge — displays a tier badge for paid users.
 * Returns null for free, starter, null, or unrecognised tiers.
 *
 * Props:
 *   tier  — 'pro' | 'premium' | 'professional' | 'business' | 'free' | 'starter' | null
 *   size  — 'sm' | 'md' (default: 'md')
 */
function PlanBadge({ tier, size = 'md' }) {
  if (!tier || tier === 'free' || tier === 'starter') return null;

  const sm = size === 'sm' ? ' plan-badge-sm' : '';

  if (tier === 'pro') {
    return (
      <span className={`plan-badge plan-badge-pro${sm}`}>
        <i className="fas fa-crown"></i>
        Pro
      </span>
    );
  }

  if (tier === 'premium') {
    return (
      <span className={`plan-badge plan-badge-premium${sm}`}>
        <i className="fas fa-gem"></i>
        Premium
      </span>
    );
  }

  if (tier === 'professional') {
    return (
      <span className={`plan-badge plan-badge-professional${sm}`}>
        <i className="fas fa-briefcase"></i>
        Professional
      </span>
    );
  }

  if (tier === 'business') {
    return (
      <span className={`plan-badge plan-badge-business${sm}`}>
        <i className="fas fa-building"></i>
        Business
      </span>
    );
  }

  // Unrecognised tier — render nothing
  return null;
}

export default PlanBadge;
